csui.require.config({
  bundles: {
'viewx/bundles/viewx-all': [
'viewx/commands/open/open.viewx',
'viewx/commands/open/impl/open.plugins',
'viewx/commands/preview/preview.viewx',
'viewx/commands/preview/impl/preview.plugins',
'viewx/commands/preview/doc.preview',
'viewx/commands/preview/impl/doc.preview.view',
'viewx/commands/preview/impl/open.document.delegates.plugin',
'viewx/commands/preview/favoritestable.toolitems',
'viewx/commands/preview/metadata.headermenuitems',
'viewx/commands/preview/nodestable.headermenuitems',
'viewx/commands/preview/nodestable.toolitems',
'viewx/commands/preview/renditions.toolitems',
'viewx/commands/preview/search.results.toolitems',
'viewx/commands/preview/tileview.accessed.toolbaritems',
'viewx/commands/preview/tileview.generic.toolbaritems',
'viewx/commands/preview/tileview.reserved.toolbaritems',
'viewx/commands/preview/versions.toolitems',
'viewx/commands/preview/workspace.header.toolbaritems',
'viewx/commands/transform/transform',
'viewx/commands/transform/download',
'viewx/commands/transform/retry',
'viewx/commands/transform/nodestable.toolitems',
'viewx/commands/transform/search.results.toolitems',
'viewx/commands/compare/compare.command',
'viewx/commands/compare/compare.nodestable.toolitems',
'viewx/commands/compare/compare.versions.toolitems',
'viewx/commands/compare/compare.search.results.toolitems',
'viewx/contexts/factories/doc.model.factory',
'viewx/contexts/perspective/plugins/node/impl/viewx.node.extra.data',
'viewx/contexts/perspective/routers/viewer.perspective.router',
'viewx/contexts/perspective/impl/plugins/viewer.perspective.context.plugin',
'json!viewx/contexts/perspective/impl/perspectives/viewer.json',
'viewx/controls/form/fields/alpcachefield',
'viewx/controls/form/fields/cacheStatus',
'viewx/controls/icons.v2/icons.v2',
'viewx/controls/node.state/node.state.icons',
'viewx/controls/node.state/markup.indicator/markup.indicator.view',
'viewx/dialogs/node.picker/start.locations/workflow.attachments/workflow.attachments.factory',
'viewx/dialogs/node.picker/start.locations/workflow.attachments/workflow.attachments',
'viewx/models/annotation/annotation.filters',
'viewx/models/annotation/annotation.filter',
'viewx/models/annotation/annotation.groups',
'viewx/models/annotation/annotation.node',
'viewx/models/deeplink/deeplink.model',
'viewx/models/annotation/markup.service.groups',
'viewx/models/member/member.model',
'viewx/models/member/member.server.adaptor.mixin',
'viewx/models/metadata/metadata.forms',
'viewx/models/publication/publication',
'viewx/models/publication/publications',
'viewx/models/rendition/version.renditions',
'viewx/models/rendition/version.rendition',
'viewx/models/token/auth',
'viewx/models/transform/transform.options.model',
'viewx/models/transform/transforms.factory',
'viewx/models/transform/transform.models',
'viewx/models/transform/transform.model',
'viewx/models/transform/transform.column.models',
'viewx/models/viewer/component.model',
'viewx/models/viewer/plugin.model',
'viewx/models/viewer/plugin.models',
'viewx/models/viewer/viewer.model',
'viewx/models/viewer/viewer.models',
'viewx/utils/transform',
'viewx/utils/utils',
'viewx/utils/options',
'viewx/utils/viewer/loader',
'viewx/utils/viewer/config',
'viewx/utils/viewer/plugins',
'viewx/utils/viewer/core.smart.nodes',
'viewx/utils/viewer/default.action.items',
'viewx/utils/context.help/context.help.ids',
'viewx/widgets/export/export.view',
'viewx/widgets/iv.view/iv.view.view',
'viewx/widgets/metadata/metadata.panels',
'viewx/widgets/metadata/mixins/property.panel.mixin',
'viewx/widgets/metadata/property.panels/annotation/annotation.properties.controller',
'viewx/widgets/metadata/property.panels/rendition/rendition.properties.controller',
'viewx/widgets/metadata/property.panels/rendition/impl/rendition.properties.view',
'viewx/widgets/metadata/property.panels/banner/banner.properties.controller',
'viewx/widgets/metadata/property.panels/persona/persona.properties.controller',
'viewx/widgets/metadata/property.panels/persona/impl/persona.properties.view',
'viewx/widgets/metadata/property.panels/persona/impl/persona.properties.model',
'viewx/widgets/metadata/property.panels/prepublish/prepublish.properties.controller',
'viewx/widgets/transform/transform.view',
'viewx/widgets/transform/impl/transform.options.view',
'viewx/widgets/transformstatus/transformstatus.view',
'viewx/widgets/transformstatustile/transformstatustile.view',
'viewx/widgets/transformtable/transformtable.view',
'viewx/widgets/transformtable/impl/controls/cells/transform.cells.view',
'viewx/widgets/viewer/impl/annotation.panel/annotation.filters.view',
'viewx/widgets/viewer/impl/annotation.panel/annotation.panel.view',
'viewx/widgets/viewer/impl/erroritems.view',
'viewx/widgets/viewer/viewer',
'viewx/widgets/viewer/viewer.view',
'viewx/widgets/workflow.options/workflow.options.launcher',
'json!viewx/widgets/transformstatustile/transformstatustile.manifest.json',
'viewx/widgets/transformstatustile/impl/nls/transformstatustile.manifest',
'viewx/widgets/transformstatustile/impl/nls/root/transformstatustile.manifest'
]
  }
});